<app-api-loader></app-api-loader> <router-outlet></router-outlet>
